<template>
    <div class="mian_page">
        <div class="desktop-element">
            <div class="page_hx flex-col">
                <my-menu class="sticky-menu" :default-active-index="2"></my-menu>
                <advisory-banner :imageUrl="aboutBanner"></advisory-banner>
                <type-select  :selected-index="2" @change="changeType" :key="`type-${Date.now()}-2`"></type-select>
                <div class="div_content">
                    <div class="section_4 flex-row justify-between">
                        <div class="group_13 flex-col">
                            <div class="block_13 flex-row justify-between">
                                <div class="image-text_11 flex-row justify-between">
                                    <img
                                            class="label_1"
                                            referrerpolicy="no-referrer"
                                            src="../../assets/advisory/advisory_select_type1_02.png"
                                    />
                                    <span class="text-group_3">企业健康咨询</span>
                                </div>
                                <span class="text_18">Consultation</span>
                            </div>
                            <img
                                    class="image_7"
                                    referrerpolicy="no-referrer"
                                    src="./assets/img/SketchPng058f619c4fb320f70ecaf25f56f7aeef8e86cb75e1a2bd6987e3454070ae04d8.png"
                            />
                            <div class="text-group_19 flex-col justify-between">
                          <span class="text_19">
                            依托近二十年、100余家药械及大健康行业客户服务经验，我们为销售、商务、运营、采购、财务和内控等多部门提供全生命周期风控与企业健康咨询服务。通过日益积累的行业洞察与风险防控经验，帮助厘清运营规则，优化风险防范与控制策略，助力企业在政策高压、竞争加剧的复杂环境中实现稳健可持续发展。
                          </span>
                                <span class="text_20">核心产品：合规核查、合规管理、数据健康评估、营销智慧核查</span>
                            </div>
                        </div>
                        <div class="block_5_wraper">
                            <div class="block_5 flex-col" :style="{ backgroundImage: 'url(' + aboutImageUrl + ')' }" ></div>
                        </div>
                    </div>
                    <core-select></core-select>
                    <solve-index></solve-index>

                    <div class="section_10 flex-col">
                        <div class="block_6 flex-col" :style="{ backgroundImage: 'url(' + imgOrMp4 + ')' }"></div>
                    </div>
                    <div class="section_11 flex-col">
                        <div class="text-wrapper_5">
                            <span class="text_30">协助达成“风险可控的增长”</span>
                            <span class="paragraph_1"><br /></span>
                            <span class="text_31">-&nbsp;康柏汉森为企业构建从风险防御到价值创造的健康生态&nbsp;-</span>
                        </div>
                    </div>
                </div>

                <ChpcFooter></ChpcFooter>
                <contact-float v-show="isVisible" @change="change" />
                <contact-dialog v-show="!isVisible" @showContact="showContact"></contact-dialog>
            </div>
        </div>

        <div class="mobile-element">
            <div class="mobile-page flex-col">
                <mobile-header class="sticky-menu-mobile" :default-active-index="2"></mobile-header>
                <div class="mobile-link">
                    <mobile-link :default-active-index="2"></mobile-link>
                    <mobile-banner :contactBanner="aboutBanner"></mobile-banner>
                    <div class="div_type_select">
                        <mobile-type :selected-index="2" @change="changeType" key="mobile1"></mobile-type>
                    </div>
                    <mobile-introduce :introItem="introItem"></mobile-introduce>
                    <mobile-core :core-info="coreData"></mobile-core>
                    <mobile-solve-index></mobile-solve-index>
                    <div class="section_10_mobile flex-col">
                        <div class="block_6_mobile flex-col" :style="imgOrMp4Style"></div>
                    </div>
                    <div class="section_11_mobile flex-col">
                        <div class="text-wrapper_5_mobile">
                            <span class="text_30">协助达成“风险可控的增长”</span>
                            <span class="paragraph_1"><br /></span>
                            <span class="text_31">-&nbsp;康柏汉森为企业构建从风险防御到价值创造的健康生态&nbsp;-</span>
                        </div>
                    </div>
                </div>
                <mobile-footer @contactMobile="contactMobile"></mobile-footer>
                <mobile-contact-dialog v-show="isVisibleMobile" @closeMobileContact="closeMobileContact"></mobile-contact-dialog>

            </div>
        </div>

    </div>
</template>
<script>
    import myMenu from "@/views/Component/ChpcMenu.vue";
    import ContactFloat from "@/views/Component/Contact.vue";
    import ContactDialog from "@/views/Component/ContactDialog";
    import advisoryBanner from "./childPage/advisoryBanner";
    import typeSelect from "./childPage/typeSelect";
    import coreSelect from "./childPage/coreConsultation";
    import solveIndex from "./childPage/solveConsultation";
    import ChpcFooter from "@/views/Component/ChpcFooter";
    //mobile
    import MobileHeader from "@/views/Component/MobileHeader";
    import MobileLink from "@/views/Component/MobileLink";
    import MobileFooter from "@/views/Component/MobileFooter";
    import MobileType from "./childPage/MobileType";
    import MobileIntroduce from "./childPage/MobileIntroduce";
    import MobileCore from "./childPage/MobileCore";
    import MobileSolveIndex from "./childPage/MobileSolveConsulation";
    import MobileContactDialog from "@/views/Component/MobileContactDialog";
    import MobileBanner from "./childPage/MobileBanner";
    import {isNull} from "../../common/testFun";
    import commonFun from "@/util/common.js";

    export default {
        name: "consultationIndex",
        metaInfo:{
            title:'北京康柏汉森医药科技咨询有限责任公司',
            meta:[{name: 'keyWords', content:'官网，CHPC，医药咨询，康柏汉森，医药科技咨询；医药企业营销咨询；企业管理咨询；商务咨询'},
                {name:'description', content:'简称CHPC, CHPC起步于医药行业,中国医药行业内风险控制领域的服务提供商，提供渠道核查、合规核查、信息技术、管理咨询服务'},
                {name:"robots",content:"北京康柏汉森医，企业健康咨询"},
            ]
        },
        computed: {
            imgOrMp4Style() {
                return {
                    backgroundImage: `url(${this.imgOrMp4})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat'
                };
            }
        },
        data() {
            return {
                aboutBanner:require('@/assets/advisory/advisory_bj_02.png'),
                aboutImageUrl:require('@/assets/advisory/advisory_select_type_bj03.png'),
                imgOrMp4: require('@/assets/advisory/advisory_index_solve01.png'),
                isVisible:true,
                isVisibleMobile:false,
                introItem:{
                    title:'企业健康咨询',
                    enTitle:'Consultation',
                    content:'依托近二十年、100余家药械及大健康行业客户服务经验，我们为销售、商务、运营、采购、财务和内控等多部门提供全生命周期风控与企业健康咨询服务。通过日益积累的行业洞察与风险防控经验，帮助厘清运营规则，优化风险防范与控制策略，助力企业在政策高压、竞争加剧的复杂环境中实现稳健可持续发展。',
                    production:'核心产品：合规核查、合规管理、数据健康评估、营销智慧核查',
                    img:require('@/assets/advisory/advisory_select_type_bj03.png'),
                    labelIcon: require('@/assets/advisory/advisory_select_type1_02.png'),
                },
                coreData: {
                    detailImg: require('../../assets/advisory/advisory_core_select03.png'),
                    items: [
                        {
                            icon: require('../../assets/home/chpc_about_industry_03.png'),
                            text: '定制化诊断精准匹配企业健康需求',
                            content:'基于100余家药械及大健康行业客户服务经验，构建“业务-财务-合规”三维诊断模型，覆盖学术推广、渠道窜货、费用黑洞等20+风险场景，精准识别业务盲区，为企业提供深度定制化健康方案。',
                        },
                        {
                            icon: require('../../assets/home/chpc_about_industry_04.png'),
                            text: '跨部门协同解决方案',
                            content:'打通销售、财务、供应链等多部门数据壁垒，通过智慧化综合评估系统与资深人员专业研判，量化风险敞口与增长潜力，提供端到端优化策略。',
                        },
                        {
                            icon: require('../../assets/home/chpc_about_industry_05.png'),
                            text: '全链路诊断营销效能',
                            content:'全链路核查营销活动的计划管理、落地实施、结果产出，进行费用与效果关联分析，诊断识别无效投入与潜力场景，重构资源分配策略，助力客户营销ROI提升。',
                        },
                        {
                            icon: require('../../assets/home/chpc_about_industry_06.png'),
                            text: '数字化赋能工具',
                            content:'自主研发企业健康智慧中心，涵盖AI作业工具集与多维风险评估平台，集成风险预警、合规自检、决策模拟等功能，实现风险管理的实时化与可视化。',
                        }
                    ],
                }
            };
        },

        components:{
            myMenu,ChpcFooter,advisoryBanner,typeSelect,coreSelect,solveIndex,ContactDialog,ContactFloat,
            MobileHeader,MobileLink,MobileFooter,MobileType,MobileIntroduce,MobileCore,MobileSolveIndex,
            MobileContactDialog,MobileBanner

        },
        mounted() {
            this.getPic();
        },
        methods: {
            change(){
                this.isVisible = false;
            },
            showContact(){
                this.isVisible = true;
            },
            contactMobile(){
                this.isVisibleMobile = true;
            },
            closeMobileContact(){
                this.isVisibleMobile = false;
            },
            changeType(index) {
                this.currentIndex = index; // 当子组件触发 change 时更新状态
                if(index == 0){
                    this.goto("Advisory");
                }else if(index == 1){
                    this.goto("compliance");
                }else if(index == 2){
                    this.goto("consultation");
                }
            },
            goto(url){
                url = '/' + url;
                this.$router.push(url);
            },
            getPic(){
                let pic ={model:3}
                this.$HTTP.getPicByModel(pic).then(resp => {
                    if(resp.code == 200){
                        let data = resp.data;
                        if(data && data.length>0){
                            let picarr= commonFun.dealPic(data,1,false);
                            if(picarr && picarr.length>0){
                                this.aboutBanner = picarr;
                            }
                            let aboutImg = commonFun.dealPic(data,4,false);
                            if(!isNull(aboutImg)){
                                this.aboutImageUrl = aboutImg;
                            }
                            let aboutImg5 = commonFun.dealPic(data,5,false);
                            if(!isNull(aboutImg5)){
                                this.imgOrMp4 = aboutImg5;
                            }
                        }
                    }
                });
            }
        }
    };
</script>
<style scoped lang="css" src="./css/index.css" />
